import {isPlainObject as rawIsPlainObject, reduce} from 'lodash';

export type Cleaned<T> = T extends Record<string, unknown>
  ? {
      [K in keyof T as K extends '__typename' ? never : K]: Cleaned<T[K]>;
    }
  : T extends ReadonlyArray<infer P>
  ? ReadonlyArray<Cleaned<P>>
  : T extends Array<infer P>
  ? Array<Cleaned<P>>
  : T;

const isPlainObject = (arg: unknown): arg is object => rawIsPlainObject(arg);

export const rejectTypenameDeep = <T,>(input: T): Cleaned<T> =>
  // use isPlainObject here to prevent reducing functions, class instances,
  // and other object-like constructs. isPlainObjectTypeguard just adds a
  // typeguard so that TS knows that if true, then the input is an object
  // (the lodash function doesn't include this for some reason)
  isPlainObject(input) || Array.isArray(input)
    ? reduce(
        input,
        (acc, value, key: string | number) => {
          if (key !== '__typename') {
            // @ts-expect-error - TS7053 - Element implicitly has an 'any' type because expression of type 'string | number' can't be used to index type 'unknown'. | No index signature with a parameter of type 'string' was found on type 'unknown'.
            acc[key] = rejectTypenameDeep(value);
          }
          return acc;
        },
        (Array.isArray(input) ? [] : {}) as Cleaned<T>,
      )
    : (input as Cleaned<T>);
